import React from "react"
export function UpChevronOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-1a7 7 0 110-14 7 7 0 010 14zm3.506-5.186l.988-1.128-4-3.5a.75.75 0 00-.9-.067l-.088.067-4 3.5.988 1.128 3.505-3.067 3.507 3.067z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__up-chevron---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
